<template>
  <div>
    <Button
      type="no-border"
      @click="toggleNote"
      v-show="!showNote"
      class="add-note-link"
      icon="icon icon-note"
    >
      {{ $t('form.invoiceForm.addNote') }}
    </Button>

    <CollapseTransition>
      <FormSection
        is-new
        v-show="showNote"
        class="invoice-note-section"
      >
        <FormGroup
          prop="note"
          :label="$t('form.invoiceForm.fields.notes.label')"
          :help="$t('form.invoiceForm.fields.notes.inputHelp')"
          floating-label
          :input-value="note"
        >
          <TextInput
            name="note"
            type="textarea"
            rows="3"
            v-model="note"
            id="invoice_note"
          />
        </FormGroup>
      </FormSection>
    </CollapseTransition>
  </div>
</template>

<script>
import { mapFields } from 'vuex-map-fields';
import { isEmpty } from 'ramda';
import Cookies from 'js-cookie';

export default {
  name: 'InvoiceNote',
  data: () => ({
    showNote: false,
  }),
  computed: {
    ...mapFields('invoiceForm', [
      'note',
    ]),
  },
  methods: {
    toggleNote() {
      this.showNote = true;
      Cookies.set('showNoteSettings', this.showNote);
    },
  },
  created() {
    const unwatchNote = this.$watch('note', (newVal) => {
      this.showNote = !isEmpty(newVal);

      const showNoteFromCookie = Cookies.get('showNoteSettings');
      if (typeof showNoteFromCookie !== 'undefined') {
        this.showNote = true;
      }

      if (unwatchNote) {
        unwatchNote();
      }
    }, { immediate: true });
  },
};
</script>

<style lang="scss" scoped>
.add-note-link {
  margin-top: 2rem;
}

.invoice-note-section {
  margin-top: 3rem;
}
</style>
